import React from 'react'
import { Typography } from 'antd'
import { CurrencyFormatWithDecimal } from '../../../helper/CurrencyFormate'
import { CURRENCY } from '../../../utils/ConstantData'

const CustomAmountText = ({value, shouldDisplayCurrency = false}) => {
  return (
    <Typography.Text {...(parseFloat(value) < 0 ? { type: "danger" } : {})}>{CurrencyFormatWithDecimal(value, null, CURRENCY, shouldDisplayCurrency)}</Typography.Text>
  )
}

export default CustomAmountText